import React from "react";
import './main.css';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { Provider } from 'react-redux';
//import { Analytics } from "@vercel/analytics/react";
import { store } from './store';
import { CoachProvider } from "./CoachProvider";
import { TokenProvider } from "./TokenProvider";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <TokenProvider>
        <CoachProvider>
          <App />
        </CoachProvider>
      </TokenProvider>
      {/* <Analytics /> */}
    </Provider>
  </BrowserRouter>
);


